module.exports = __webpack_public_path__ + "static/img/4g-fg-key-dem.2f7ceec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/remotekey/finger/4g-fg-key-dem.png
// module id = 3Dng
// module chunks = 0